const yellowBackgrounds = new Set([
  'rgb(251, 190, 9)',
  'rgb(251, 192, 9)',
  'rgb(255, 193, 7)',
]);

const blackBackgrounds = new Set([
  'rgb(0, 0, 0)',
  'rgb(47, 47, 47)',
  'rgb(51, 51, 51)',
]);

const transparentBackgrounds = new Set([
  'rgba(0, 0, 0, 0)',
  'transparent',
]);

const blackBorders = new Set([
  'rgb(0, 0, 0)',
  'rgb(47, 47, 47)',
  'rgb(51, 51, 51)',
]);

const actionSelector = 'a, button, input[type="button"], input[type="submit"], input[type="reset"]';
const excludedSelector = [
  '.button-unstyled',
  '.yx-product-card__favorite',
  '.yx-product-card__info',
  '.yx-product-card__button',
  '.yx-product-card__media-link',
  '.yx-site-header__discount-icon',
  '.yx-home__hero-tab',
  '.yx-home__stripe-dots',
  '.yx-site-footer__service-strip',
  '.yx-site-footer__trustpilot',
  '.yx-home__review-actions button',
  '.yx-home__system-actions button',
  '.yx-home__article-arrows button',
  '.main-product__sizes button',
  '.main-product__swatches button',
  '.main-product__thumb',
  '.main-product__stage-arrow',
  '.main-product__story-arrows button',
  '.main-product__related-arrows button',
  '.main-collection__mobile-more a',
  '.yx-search__more div > a',
  '[data-yx-quick-buy-value]',
  '.variant-option__button-label',
  '.yx-grid-promo',
  '.yx-collection__grid-promo',
  '[class*="arrow"]',
  '[class*="chevron"]',
].join(',');

function hasActionLabel(element) {
  if (element instanceof HTMLInputElement) return element.value.trim().length > 1;
  return element.textContent?.trim().length > 1;
}

function isYellowCta(element) {
  if (!(element instanceof HTMLElement) || element.matches(excludedSelector) || !hasActionLabel(element)) return false;

  const box = element.getBoundingClientRect();
  if (box.width < 64 || box.height < 28) return false;

  const styles = getComputedStyle(element);
  return yellowBackgrounds.has(styles.backgroundColor);
}

function isBlackCta(element) {
  if (!(element instanceof HTMLElement) || element.matches(excludedSelector) || !hasActionLabel(element)) return false;

  const box = element.getBoundingClientRect();
  if (box.width < 64 || box.height < 28) return false;

  return blackBackgrounds.has(getComputedStyle(element).backgroundColor);
}

function isOutlineCta(element) {
  if (!(element instanceof HTMLElement) || element.matches(excludedSelector) || !hasActionLabel(element)) return false;

  const box = element.getBoundingClientRect();
  if (box.width < 64 || box.height < 28) return false;

  const styles = getComputedStyle(element);
  return (transparentBackgrounds.has(styles.backgroundColor) || styles.backgroundColor === 'rgb(255, 255, 255)')
    && blackBorders.has(styles.borderColor)
    && Number.parseFloat(styles.borderTopWidth) > 0;
}

function yellowCtaPlateIn(action) {
  return [...action.querySelectorAll('*')].find((element) => isYellowCta(element));
}

function markYellowCtas(scope = document) {
  const elements = [];
  if (scope instanceof Element && scope.matches(actionSelector)) elements.push(scope);
  scope.querySelectorAll?.(actionSelector).forEach((element) => elements.push(element));

  elements.forEach((element) => {
    if (element.matches('.yx-yellow-cta, .yx-black-cta, .yx-outline-cta, .yx-yellow-cta-owner')) return;

    if (isYellowCta(element)) {
      element.classList.add('yx-yellow-cta');
      return;
    }

    if (isBlackCta(element)) {
      element.classList.add('yx-black-cta');
      return;
    }

    if (isOutlineCta(element)) {
      element.classList.add('yx-outline-cta');
      return;
    }

    const plate = yellowCtaPlateIn(element);
    if (!plate) return;

    element.classList.add('yx-yellow-cta-owner');
    plate.classList.add('yx-yellow-cta');
  });
}

let scanQueued = false;
const pendingScopes = new Set();

function queueYellowCtaScan(scope = document) {
  pendingScopes.add(scope);
  if (scanQueued) return;
  scanQueued = true;
  requestAnimationFrame(() => {
    scanQueued = false;
    pendingScopes.forEach((pendingScope) => markYellowCtas(pendingScope));
    pendingScopes.clear();
  });
}

function initYellowCtaHover() {
  queueYellowCtaScan();

  // Drawers and quick-buy panels can reveal their CTAs after the first scan.
  // Mark the actual textual control as it becomes interactive as well.
  const queueActionScope = (event) => {
    if (!(event.target instanceof Element)) return;
    const action = event.target.closest(actionSelector);
    if (action) queueYellowCtaScan(action);
  };

  document.addEventListener('pointerover', queueActionScope, { passive: true });
  document.addEventListener('focusin', queueActionScope);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) queueYellowCtaScan(node);
      });
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initYellowCtaHover, { once: true });
} else {
  initYellowCtaHover();
}
